export default "__VITE_ASSET__BnytVaSe__"